import { Injectable } from '@angular/core';
import {MessageService} from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(private messageService: MessageService) {}

  /**
   * Show a success toast message
   * @param message The message to display
   * @param title Optional title for the toast
   */
  toastSuccess(message: string, title: string = 'Sucesso'): void {
    this.messageService.add({
      severity: 'success',
      summary: title,
      detail: message,
      life: 5000
    });
  }

  /**
   * Show an error toast message
   * @param message The message to display
   * @param title Optional title for the toast
   */
  toastError(message: string, title: string = 'Erro'): void {
    this.messageService.add({
      severity: 'error',
      summary: title,
      detail: message,
      life: 5000
    });
  }

  /**
   * Show a warning toast message
   * @param message The message to display
   * @param title Optional title for the toast
   */
  toastWarning(message: string, title: string = 'Atenção'): void {
    this.messageService.add({
      severity: 'warn',
      summary: title,
      detail: message,
      life: 5000
    });
  }

  /**
   * Show an info toast message
   * @param message The message to display
   * @param title Optional title for the toast
   */
  toastInfo(message: string, title: string = 'Informação'): void {
    this.messageService.add({
      severity: 'info',
      summary: title,
      detail: message,
      life: 5000
    });
  }
}
